// extracted by mini-css-extract-plugin
export default {"container":"VyVDj1","mixed":"YSG81k","ingredients":"vgDZaf","divider":"BL18O4"};